import styled from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'
import { font, colors } from '@chegg-ui/theme'
import fanta from '@chegg-wt/core/theme/fanta/theme'

interface StyledSubHeadingBCOtherPagesProps {
  formPage: boolean
  citationFD: boolean
  fontSizeOverride?: string
}

export const StyledSubHeadingBCHomePage = styled.h2`
  font-weight: bold;
  color: ${colors.dark};
  font-size: 30px;
  /* display: inline-block; */
  margin: 6px 0 0 0;
  @media (max-width: 599px) {
    font-size: 24px;
  }
`

export const StyledSubHeadingBCOtherPages = styled.h2<StyledSubHeadingBCOtherPagesProps>`
  display: inline;
  && {
    ${AspiraStack};
    font-weight: ${fanta.font.weight.bold};
    color: ${colors.dark};
    margin: ${fanta.spacing.fanta.lg} 0 6px 0;

    font-size: ${({ fontSizeOverride }) => fontSizeOverride || font.size.px42};
    line-height: 44px;
    display: inline;

    // 'font.size.xxxl' for smaller breakpoints
    @media (max-width: 899px) {
      font-size: 2.25rem;
      line-height: 40px;
    }

    @media (max-width: 599px) {
      font-size: 1.875rem;
      line-height: 34px;
    }
  }
  ${(props) =>
    props.formPage &&
    `&&& {
    ${AspiraStack};
    font-weight: ${font.weight.bold};
    font-size: ${font.size.px42};
    line-height: 44px;

    @media (min-width: 621px) and (max-width: 1279px) {
      font-size: 2.25rem;
      line-height: 40px;
    }
    @media (max-width: 620px) {
      font-size: 1.875rem;
      line-height: 34px;
    }
  }`}
  ${(props) =>
    props.citationFD &&
    `&&& {
    ${AspiraStack};
    font-size: ${fanta.font.text.size['2xl']};
    font-weight: ${fanta.font.weight.bold};
    letter-spacing: 0;
    line-height: 36px;
  }`}
`
